import type { OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import type { UserInputValues } from '@tectonics/prs/user-input-values';

export function mobileMoneyOutgoingPaymentMapper(userInputValues: UserInputValues): Partial<OutgoingPayment> {
  const network = userInputValues['selectedMobileMoneyNetwork'];

  return {
    payment_type: 'ewallet',
    payment_type_code: typeof network === 'string' ? network : '',
  };
}
